import React, { useEffect, useState } from 'react';
import { Download, FileText } from 'lucide-react';
import { toast } from 'react-toastify';
import { collaborationService } from '../api/collaboration-service';

export default function ProtectedAttachment({ attachment }) {
  const [preview, setPreview] = useState(null);
  const isPdf = attachment.mimeType === 'application/pdf';

  useEffect(() => {
    if (!attachment.previewUrl) return undefined;
    const controller = new AbortController();
    let objectUrl;
    collaborationService.attachmentUrl(attachment.previewUrl, { signal: controller.signal })
      .then((response) => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(response.data);
        setPreview(objectUrl);
      })
      .catch((error) => {
        if (!controller.signal.aborted) toast.error(error?.message || 'Unable to preview this attachment.');
      });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attachment.previewUrl]);

  const download = async () => {
    try {
      const response = attachment.downloadUrl
        ? await collaborationService.attachmentUrl(attachment.downloadUrl)
        : await collaborationService.attachment(attachment.id);
      const url = URL.createObjectURL(response.data);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = attachment.name || 'attachment';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      toast.error(error?.message || 'Unable to download this attachment.');
    }
  };

  return (
    <div className="collab-attachment">
      {preview && attachment.isImage && <img className="collab-attachment__image" src={preview} alt={attachment.name} />}
      {preview && isPdf && <iframe className="collab-attachment__pdf" src={preview} title={`Preview ${attachment.name}`} />}
      <div className="collab-attachment__footer">
        {isPdf && <FileText size={16} aria-hidden="true" />}
        <span>{attachment.name}</span>
        <button type="button" onClick={download} aria-label={`Download ${attachment.name}`}><Download size={16} /></button>
      </div>
    </div>
  );
}
